import roundToTwoDecimals from "./roundToTwoDecimals";

/**
 * Converts int to float string (for backend parsing)
 */
export default function toFloat(number: number, digits: number = 2): string {
    return roundToTwoDecimals(number).toFixed(digits)
}